import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import GlobalPlatformParameters from "../../../../../shared/src/ranj/equalture/platform/GlobalPlatformParameters";
import PlatformAPICommand from "../../../../../shared/src/ranj/equalture/platform/PlatformAPICommand";
import PlatformAPIEventType from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIEventType";
import PlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIService";
import GameModel from "../core/model/GameModel";
import CollaborationPlatformMockAPIService from "./CollaborationPlatformMockAPIService";

export default class CollaborationInitPlatformAPIServiceTask extends Task {

    /**
     * @param {Config} config 
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {AppModel} appModel
     * @param {GameModel} gameModel
     */
    constructor(config, injector, commands, appModel, gameModel) {
        super();

        this.execute = function (callback) {
            const version = config.getValue(Config.VERSION);

            const isMockPlatform = getURLParameter("mockapi") === "1" || ranj.DEBUG;
            injector.mapClass("platformAPIService", isMockPlatform ? CollaborationPlatformMockAPIService : PlatformAPIService, true);
            if (isMockPlatform) {
                console.info("InitPlatformAPIServiceTask, using MockPlatformAPIService.");
            }

            commands.add(PlatformAPIEventType.INTERACTION, PlatformAPICommand);
            commands.add(PlatformAPIEventType.PROGRESS, PlatformAPICommand);
            commands.add(PlatformAPIEventType.SAVE_REQUEST, PlatformAPICommand);

            /**@type {PlatformAPIService} */
            const platformAPIService = injector.getValue("platformAPIService");
            platformAPIService.initialize(version);
            platformAPIService.getGlobalConfigurationAsync()
                .then(parameters => this._applyGlobalPlatformConfiguration(parameters))
                .finally(_ => {
                    platformAPIService.enableLogging(getURLParameter("logapi") == "1");
                    console.log(`InitPlatformAPIServiceTask completed.`);
                    callback(this);
                });
        };

        /**
         * Applies platform configuration/ parameters to game models.
         * @param {GlobalPlatformParameters} platformParameters 
         */
        this._applyGlobalPlatformConfiguration = function (platformParameters) {
            appModel.language = getURLParameter("lang") ?? platformParameters.language;
            appModel.playMode = getURLParameter("mode") ?? platformParameters.playMode;
            appModel.environment = platformParameters.environment;
            
            gameModel.setScenarioStatesFromObject(platformParameters.payload.episodes);
        };
    }
}